// extracted by mini-css-extract-plugin
export default {"upgrade":"upgrade-R9fx","pic":"pic-gXiJ","title":"title-HlB8","headline":"headline-TdLb"};